import { useState } from 'react';
import { Plus } from 'lucide-react';
import { PageHeader } from '@/layouts/PageHeader.js';
import { MemoriesGridView } from '@/components/memories/MemoriesGridView.js';
import { SearchInput } from '@/components/common/SearchInput.js';
import { Button } from '@/components/ui/button.js';

export function MemoriesOverlay() {
  const [searchQuery, setSearchQuery] = useState('');
  const [showAddModal, setShowAddModal] = useState(false);

  return (
    <div className="absolute inset-0 bg-muted/30 backdrop-blur-sm z-10 flex flex-col animate-in slide-in-from-right-10 duration-200">
      <PageHeader
        title="Memories"
        subtitle="Your knowledge base"
        actions={
          <>
            <SearchInput
              placeholder="Search memories..."
              value={searchQuery}
              onChange={setSearchQuery}
            />
            <Button onClick={() => setShowAddModal(true)} className="gap-2">
              <Plus className="h-4 w-4" />
              Add Memory
            </Button>
          </>
        }
      />
      <main className="flex-1 overflow-hidden">
        <MemoriesGridView
          searchQuery={searchQuery}
          showAddModal={showAddModal}
          onCloseAddModal={() => setShowAddModal(false)}
        />
      </main>
    </div>
  );
}


